import React, { useState, lazy, Suspense, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { isUiSelectOpenSelector } from 'domain/ui';

import TabContext from '@mui/lab/TabContext';
import LinearProgress from '@mui/material/LinearProgress';
import { PaymentTab, PaymentTabList, PaymentTabPanel, PaymentTabsRoot } from './StyledCompoents';

import { storage } from 'lib/storage';

import PaymentIcon from '@mui/icons-material/Payment';
import HistoryIcon from '@mui/icons-material/History';

const PaymentDetails = lazy(() => import('pages/dokkaPay/pages/payment/components/PaymentDetails'));
const PreviousPaymentGrid = lazy(() => import('pages/dokkaPay/pages/payment/components/PreviousPaymentGrid'));

const tabs = {
  paymentDetails: 'PAYMENT_DETAILS',
  previousPayments: 'PREVIOUS_PAYMENTS',
};

const PaymentTabs: React.FC = () => {
  const { formatMessage } = useIntl();

  const previousPaymentsIsActive = JSON.parse(storage().previousPaymentsIsActive().get() ?? 'null');
  const [tab, setTab] = useState(previousPaymentsIsActive ? tabs.previousPayments : tabs.paymentDetails);
  const isUiSelectOpen = useSelector(isUiSelectOpenSelector);

  const handleChange = useCallback((_event: React.SyntheticEvent, tabKey: string) => {
    setTab(tabKey);
    storage()
      .previousPaymentsIsActive()
      .set(tabKey === tabs.previousPayments);
  }, []);

  return (
    <TabContext value={tab}>
      <PaymentTabsRoot>
        <PaymentTabList onChange={handleChange}>
          <PaymentTab
            value={tabs.paymentDetails}
            icon={<PaymentIcon />}
            iconPosition="start"
            label={formatMessage({ id: 'payment.tabs.paymentDetails.title', defaultMessage: 'Payment Details' })}
          />
          <PaymentTab
            label={formatMessage({ id: 'payment.tabs.previousPayment.title', defaultMessage: 'Previous Payment' })}
            value={tabs.previousPayments}
            icon={<HistoryIcon />}
            iconPosition="start"
          />
        </PaymentTabList>

        <PaymentTabPanel value={tabs.paymentDetails} sx={{ overflowY: isUiSelectOpen ? 'hidden' : 'auto' }}>
          <Suspense fallback={<LinearProgress />}>
            <PaymentDetails />
          </Suspense>
        </PaymentTabPanel>
        <PaymentTabPanel value={tabs.previousPayments}>
          <Suspense fallback={<LinearProgress />}>
            <PreviousPaymentGrid />
          </Suspense>
        </PaymentTabPanel>
      </PaymentTabsRoot>
    </TabContext>
  );
};

export default PaymentTabs;
